import type { SymbolDefinition } from "../types.ts";

export const relay: SymbolDefinition = {
  id: "ep-relay",
  familyKey: "relay",
  deviceKind: "relay",
  version: "0.1.0",
  label: { sv: "Relä", en: "Relay" },
  description: { sv: "Reläspole.", en: "Relay coil." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="6" y="8" width="12" height="8"/>
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "A1", kind: "control", label: "A1", position: "top", offset: 0.5 },
    { id: "A2", kind: "control", label: "A2", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "K",
  searchKeywords: ["relä", "relay"],
};
